var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import ts, { factory } from "typescript";
import { createFunctionalComponent, createJsxSelfClosingElement, createJsxAttribute } from '../../react-components/react-component-helper';
import { getProperties } from '../../entity/index';
import { GrommetDtTableComponents } from '../../../definition/grommet/table';
import { Formatter } from "../../../definition/context-types";
import { GeneratorHelper } from "../helper";
import ReactIntlFormatter from "../../react-components/react-intl/intl-formatter";
import { uniqueImports } from "../../../ast/imports";
import { createAst, replaceElementsToAST } from "../../../../ast";
import { findVariableDeclarations } from "../../../ast/ast";
import { findWidgetParentNode } from "../../../ast/widgetDeclaration";
var GrommetDataTableGenerator = /** @class */ (function () {
    function GrommetDataTableGenerator(generationContext, entity, widgetContext) {
        this._imports = [];
        this._helper = new GeneratorHelper(generationContext, this._imports);
        this._context = generationContext;
        this._entity = entity;
        this._widgetContext = widgetContext;
        this._intlFormatter = new ReactIntlFormatter(generationContext, this._imports);
    }
    GrommetDataTableGenerator.prototype.insertColumn = function (position, property, columnIndex) {
        return __awaiter(this, void 0, void 0, function () {
            var alteredSource, sourceCode, ast, widgetParentNode, columnsDeclarationNode, columnDeclarationArray;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        alteredSource = '';
                        if (!this._widgetContext) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._widgetContext.getSourceCodeString(position)];
                    case 1:
                        sourceCode = _a.sent();
                        ast = createAst(sourceCode);
                        if (ast) {
                            widgetParentNode = findWidgetParentNode(sourceCode, position);
                            if (widgetParentNode) {
                                columnsDeclarationNode = this.findColumnsDeclaration(widgetParentNode);
                                if (columnsDeclarationNode) {
                                    columnDeclarationArray = columnsDeclarationNode.getChildAt(2);
                                    if (columnDeclarationArray) {
                                        ast = this.addNewColumn(columnDeclarationArray, property, ast, columnIndex);
                                    }
                                }
                            }
                            alteredSource = this.printSourceCode(ast);
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/, alteredSource];
                }
            });
        });
    };
    GrommetDataTableGenerator.prototype.printSourceCode = function (sourceFile) {
        var printer = ts.createPrinter({ newLine: ts.NewLineKind.LineFeed });
        return printer.printFile(sourceFile);
    };
    GrommetDataTableGenerator.prototype.addNewColumn = function (columnDeclarationParent, property, ast, columnIndex) {
        var newColumnsDefinition = this.newColumnsDeclaration(columnDeclarationParent, property, columnIndex);
        return replaceElementsToAST(ast, columnDeclarationParent.pos, factory.createArrayLiteralExpression(newColumnsDefinition));
    };
    GrommetDataTableGenerator.prototype.findColumnsDeclaration = function (widgetParent) {
        var array = [];
        findVariableDeclarations(widgetParent, array);
        if (array.length > 0) {
            var columnDeclaration = array.filter(function (def) {
                return def.getChildAt(0).getFullText().trim() === 'columns';
            });
            if (columnDeclaration && columnDeclaration.length > 0) {
                return columnDeclaration[0];
            }
        }
        return undefined;
    };
    GrommetDataTableGenerator.prototype.newColumnsDeclaration = function (columnDeclarationParent, property, columnIndex) {
        var newElements = [];
        var oldElements = columnDeclarationParent.elements;
        var newColumnDefinition = this.createColumnDefinition(property, this.getUsedFormatter(columnDeclarationParent));
        if (columnIndex && columnIndex > 0 && columnIndex < oldElements.length + 1) {
            newElements = __spreadArray(__spreadArray(__spreadArray([], oldElements.slice(0, columnIndex - 1)), [newColumnDefinition]), oldElements.slice(columnIndex - 1));
        }
        else {
            newElements = __spreadArray(__spreadArray([], oldElements), [newColumnDefinition]);
        }
        return newElements;
    };
    GrommetDataTableGenerator.prototype.getTableDefinition = function () {
        return GrommetDtTableComponents;
    };
    GrommetDataTableGenerator.prototype.generateTableComponent = function () {
        if (this._entity) {
            var statements = this.createStatements();
            var functionalComponent = createFunctionalComponent(this._helper.getComponentName(this._entity), [this._helper.createInputParameter(this._entity)], statements);
            this._imports = __spreadArray(__spreadArray([], this._imports), this._intlFormatter.getImports());
            return { functionDeclaration: functionalComponent, imports: uniqueImports(this._imports) };
        }
        return undefined;
    };
    GrommetDataTableGenerator.prototype.createStatements = function () {
        var statements = new Array();
        var columnsIdentifier = factory.createIdentifier("columns");
        var columnsDeclaration = this.createColumns(columnsIdentifier);
        var columnAttribute = createJsxAttribute("columns", "columns");
        statements.push(factory.createVariableStatement(undefined, columnsDeclaration));
        var dataAttribute = createJsxAttribute("data", this._helper.getInputParameterIdentifier(this._entity));
        var dataGridComponent = this._helper.prepareComponent(this.getTableDefinition().table, this._imports);
        statements.push(factory.createReturnStatement(factory.createParenthesizedExpression(createJsxSelfClosingElement(dataGridComponent.tagName, [columnAttribute, dataAttribute]))));
        return statements;
    };
    GrommetDataTableGenerator.prototype.createColumns = function (columnsIdentifier) {
        var _this = this;
        var propertiesColumnDefinitions = Array();
        getProperties(this._entity).forEach(function (property) {
            propertiesColumnDefinitions.push(_this.createColumnDefinition(property, _this._context.formatter));
        });
        return factory.createVariableDeclarationList([factory.createVariableDeclaration(columnsIdentifier, undefined, undefined, factory.createArrayLiteralExpression(propertiesColumnDefinitions, true))], ts.NodeFlags.Const);
    };
    GrommetDataTableGenerator.prototype.createColumnDefinition = function (property, formatter) {
        var properties = [
            factory.createPropertyAssignment(factory.createIdentifier("property"), factory.createStringLiteral(property.getName())),
            factory.createPropertyAssignment(factory.createIdentifier("header"), this._helper.getHeaderTitle(this._entity, property))
        ];
        if (formatter) {
            if (formatter === Formatter.ReactIntl) {
                properties.push(factory.createPropertyAssignment(factory.createIdentifier("render"), this.getRender(property)));
            }
        }
        return factory.createObjectLiteralExpression(properties, false);
    };
    GrommetDataTableGenerator.prototype.getUsedFormatter = function (columnsDefinition) {
        return columnsDefinition.elements.length === 0 ? Formatter.None
            : columnsDefinition.elements[0].properties.length > 2
                ? Formatter.ReactIntl
                : Formatter.None;
    };
    GrommetDataTableGenerator.prototype.getRender = function (property) {
        var fallbackExpression = factory.createIdentifier("val");
        var propertyAccessExpression = factory.createPropertyAccessExpression(fallbackExpression, factory.createIdentifier(property.getName()));
        var expression = factory.createJsxExpression(undefined, propertyAccessExpression);
        var formattedChild;
        var formattedTag = this._intlFormatter.tryFormatPropertyUsingTag(property, expression);
        if (formattedTag) {
            formattedChild = formattedTag;
        }
        else {
            formattedChild = propertyAccessExpression;
        }
        return factory.createArrowFunction(undefined, undefined, [factory.createParameterDeclaration(undefined, undefined, undefined, factory.createIdentifier("val"), undefined, undefined, undefined)], undefined, factory.createToken(ts.SyntaxKind.EqualsGreaterThanToken), factory.createParenthesizedExpression(formattedChild));
    };
    return GrommetDataTableGenerator;
}());
export default GrommetDataTableGenerator;
